import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
import addActivity from './addActivity'
import editActivity from './editActivity'
import DatePicker from 'vue2-datepicker'
import common_helper from '../../../common_helper'
import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)

Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
export default {
	name: 'activitylist',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
		addActivity,
		editActivity,
		DatePicker,
		ProgressBar
	},

	data: function () {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listActivitytypeData: [],
			listActivitydata: [],
			addboxemodal: false,
			id: '',
			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',
			boxtypesearch: '',
			warehousesearch: '',
			searchstatus: '',
			download: false,
			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			show: '',
			limitExeed: '',
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: this.$t('activities.activityListReport'),
			assignee: '',
			userListData: '',
			showadd: true,
			selectedRow: {},
			filterData: {},
			showlist: true,
			fromDateFlt: '',
			toDateFlt: '',
			activitytypesearch: '',
			startdateErr: '',
			enddateErr: '',
			opened: [],
			listingtype: 'planlisting',
			csvData: 2,
			toCheckShowRowIndex: '',
			searchFlag: false,
			searchforFlt: '',
			ActivityListXls: [],
			dataFilter: {},
			dataFilter1: {},
			tasklisting: [],
			contentVisible: true,
			selectedList: [],
			pickerid: '',
			pickerAssignmentShow: false,
			SelectPickerErr: '',
			activitydata: {},
			username: '',
			showlist: true,
			fromDateFlt: '',
			toDateFlt: '',
			activitytypesearch: '',
			startdateErr: '',
			enddateErr: '',
			opened: [],
			listingtype: 'planlisting',
			csvData: 2,
			toCheckShowRowIndex: '',
			searchFlag: false,
			searchforFlt: '',
			ActivityListXls: [],
			dataFilter: {},
			dataFilter1: {},
			tasklisting: {},
			contentVisible: true,
			options: {
				text: {
					color: '#FFFFFF',
					shadowEnable: true,
					shadowColor: '#000000',
					fontSize: 14,
					fontFamily: 'Helvetica',
					dynamicPosition: false,
					hideText: false
				},
				progress: {
					color: '#2dbd2d',
					backgroundColor: '#635F5E'
				},
				layout: {
					height: 30,
					width: 90,
					verticalTextAlign: 61,
					horizontalTextAlign: 43,
					zeroOffset: 0,
					strokeWidth: 30,
					progressPadding: 10,
					type: 'line'
				}
			},
			options1: {},
			options2: {},
			options3: {}
		}
	},

	created: function () { },
	// when a page loads,mounted() will be call
	filters: {
		moment: function (dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.pageno = 0;

		this.user_type = userdetail.utype;
		this.username = userdetail.email;
		this.client = window.localStorage.getItem('selectedClient');
		this.warehouse = window.localStorage.getItem('selectedWarehouse');
		this.warehouseid= this.warehouse;
		this.clientid =this.client;
		if(localStorage.getItem('selectedClient')!=='undefined' && localStorage.getItem('selectedWarehouse')!=='undefined'){
			this.getActivityypeData();
			this.getUesrsList();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getUesrsList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
		this.$root.$on('localStorageChanged', (newValue) => {
            // Update your local data
            this.warehouse = newValue;
            //
            //onsole.log(newValue+"===============in event")
            // Perform any other actions needed
            this.getActivityypeData();
			this.getUesrsList();
	});

	},
	methods: {
		// getActivitydatasearch() {
		// 	this.currentPage = 1;
		// 	this.geActivitydata(2);
		// },
		selectAllCheckbox() {
			this.selectedList = []
			let flag = document.getElementById("parentCheckBox").checked
			if (flag) {
				this.selectedList = this.tasklisting.filter((item) => {
					if (item.taskstatus == "assigned" || item.taskstatus == "created") {
						document.getElementById(item.rackid).checked = true
						return item
					}

				})
			}
			else {
				this.selectedList = [];
				this.resetChildCheckbox();
			}
		},
		singleSelected(data) {
			if (document.getElementById(data.rackid).checked)
				this.selectedList.push(data);
			else if (this.selectedList != []) {
				this.selectedList = this.selectedList.filter((item) => {
					if (item.rackid != data.rackid)
						return item
				})
				this.resetParentCheckbox();
			}
			if (this.selectedList == [])
				this.resetParentCheckbox();

		},
		resetParentCheckbox() {
			if (document.getElementById("parentCheckBox"))
				document.getElementById("parentCheckBox").checked = false;
		},
		resetChildCheckbox() {
			this.tasklisting.forEach(e => {
				if (e.taskstatus == "assigned" || e.taskstatus == "created") {
					if (document.getElementById(e.rackid))
						document.getElementById(e.rackid).checked = false;
				}
			})
		},

		resetAssignData() {
			this.selectedList = [];
			if (this.tasklisting.length > 0) {
				this.resetChildCheckbox();
				this.resetParentCheckbox();
			}
			this.pickerid = '';
			this.SelectPickerErr = '';
			this.activitydata = {};
		},

		async assignOrderToPicker() {
			if (!this.pickerid) {
				this.SelectPickerErr = "user is required";
				return
			}
			else {
				this.SelectPickerErr = '';
				this.input = ({
					"clientid": Number(this.clientid),
					"userid": this.pickerid,
					"activitydetailsid": this.activitydata.activitydetailsid,
					"rackid": this.selectedList.map(e => { return e.rackid }),
					"assignedby": this.username,
				});


				let result = await common_helper.getRestApiResponse('POST', 'assignCycleCountPicker', this.input, this.$alertify)
				if (result && !result.errorDATA) {
					this.$alertify.success("user assign to cycle count task")
					this.isLoading = true;
					this.pickerAssignmentShow = false;
					this.resetAssignData();
					this.geActivitydata(2);

					// this.showRow(this.activitydata);
				}
			}
		},
		// getPickersList() {
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});

		// 	let result = await common_helper.getRestApiResponse('POST', 'getWarehousePickerList', this.input, this.$alertify)
		// 	if (result && !result.errorDATA) {
		// 		this.pickerListData = result.data.data.data;
		// 	}
		// },
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			// if (!this.limitExeed) {
			// 	this.getAuditListForXLS(3)
			// }
		},

		////////
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'warehouseid': this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected(type) {
		// 	this.warehousesearch = '';
		// 	this.listActivitydata = [];
		// 	this.pageno = this.pageCount = 0;
		// 	this.resultCount = this.totalRows = 0;

		// 	this.clientid = this.clientsearch;
		// 	if (this.clientid) {
		// 		if (!this.warehouseid || this.warehousesearch =='') {
		// 			this.getWarehouseList();
		// 		} else {
		// 			if (this.user_type == 'warehouse_user') {
		// 				this.warehousesearch = this.warehouseid;
		// 			}
		// 		}
		// 		this.getActivityypeData();
		// 	}

		// },

		// warehouseSelected(type) {
		// 	if (type == 'list') {
		// 		this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();
		// 				this.getUesrsList();
		// 			} else {
		// 				this.getActivityypeData();
		// 				this.getUesrsList();
		// 				// this.getboxdata();
		// 			}
		// 		}
		// 	} else {
		// 		this.warehouseid = this.warehouse;
		// 		this.getActivityypeData();
		// 	}
		// },
		getActivitydatasearch() {
			this.currentPage = 1;
			this.resetAssignData();
			this.geActivitydata(2);
		},
		// this function for pagination
		getActivityypeData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = {
				clientid: window.localStorage.getItem('selectedClient'),
			};

			if (this.clientid) {
				// this.isLoading = true;
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getActivityMaster',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						this.listActivitytypeData = result.data.data;
						this.isLoading = false;
					}, error => {
						console.error(error);
					})
			} else {
				this.listActivitytypeData = [];
				//	this.ClientErr = 'Client is required';
			}
		},
		dateFormat(date, type) {
			if (!date) return '';

			if (type == 1) {
				return moment(date).format('YYYY-MM-DD 00:00:00');
			} else {
				return moment(date).format('YYYY-MM-DD 23:59:00');
			}
		},
		handleClick() {
			this.download = false;
			this.id = ''
			this.geActivitydata(3);
		},

		// This function for get box list
		geActivitydata(csvCheck = 0) {
			return new Promise(async (resolve, reject) => {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');

				this.options1 = JSON.parse(JSON.stringify(this.options))
				this.options2 = JSON.parse(JSON.stringify(this.options))
				this.options3 = JSON.parse(JSON.stringify(this.options))
				this.options1.progress.color = "red";
				this.options2.progress.color = "#E9E962";
				this.options3.progress.color = "#2EC8CB";

				// var dataFilter = {};
				if (csvCheck == 2) {
					this.show = false;
					this.download = true;
					this.contentVisible = false;
					this.listingtype = "planlisting"
					this.id = ""
				}

				if (window.localStorage.getItem('selectedClient')==='undefined') {
					this.$alertify.error(this.$t('common.clientError'))
					this.pageno = this.pageCount = 0;
					this.listActivitydata = [];
					return false;
				}
				if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
					this.$alertify.error(this.$t('common.warehouseError'))
					this.pageno = this.pageCount = 0;
					this.listActivitydata = [];
					return false;
				}
				var fromDateFlt = '';
				var toDateFlt = '';
				var value = '';
				var str = '';
				this.dataFilter = {}

				if (this.fromDateFlt != "") {
					fromDateFlt = this.dateFormat(this.fromDateFlt, 1);
				}
				if (this.toDateFlt != "") {
					toDateFlt = this.dateFormat(this.toDateFlt, 2);
				}
				this.input = ({
					clientid: window.localStorage.getItem('selectedClient'),
					warehouseid: window.localStorage.getItem('selectedWarehouse'),
					offset: (this.currentPage - 1) * this.pageLimit,
					limit: this.pageLimit,
					activitystatus: this.searchstatus,
					listingtype: this.listingtype,
					activitytypeid: this.activitytypesearch,
					fromdate: fromDateFlt,
					todate: toDateFlt,
					assignedto: this.assignee,
					csvData: csvCheck,
					id: this.id
				});
				Object.entries(this.input).forEach(([k, v]) => {
					let skipkeys = ['offset', 'limit', 'csvData', 'listingtype'];

					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						if (csvCheck == 3) {
							value += k + ':' + v + ','
							this.dataFilter1 = str.concat(value);
						}
						else {
							this.dataFilter[k] = v;
						}
					}
				})
				if (this.clientid && this.warehouseid) {
					this.isLoading = true;
					await axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getActivityList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
						.then(result => {
							if (result.data.data.length > 0 && csvCheck == 1) {
								this.show = true;
								this.download = false;
								this.csvFields = {
									'activityname': this.$t('activities.activityname'),
									'createddate': this.$t('auditReport.startDate'),
									'rackid': this.$t('warehouseRacks.rackId'),
									'physicalstock': this.$t('activities.scannedStock'),
									'whrackstock': this.$t('activities.WhRackStock'),
									'skucount': this.$t('activities.SkuCount'),
									'taskstatus': this.$t('activities.taskStatus'),
									'userid': this.$t('loginUsers.userId'),
									'actualstartdate': this.$t('auditReport.startDate'),
									'actualenddate': this.$t('common.endDate'),
									'assignedto': this.$t('common.assignedTo'),
									'activitystatus': this.$t('activities.activityStatus'),
									'activitydetailsid': this.$t('activities.ActivityDetailsId'),
									'description': this.$t('common.description'),
									'eenddate': this.$t('activities.estimatedEndDate'),
									'estartdate': this.$t('activities.estimatedStartDate'),
								};
								var dateFilter = [];
								var skipFilter = [];

								csvHelper.data.jsonToCSV(this.$t('activities.activityListReport'), result.data.data, this.csvFields, dateFilter, skipFilter, this.dataFilter);
								this.isLoading = false;
								return true;
							} else if (result.data.data.length > 0 && csvCheck == 3) {
								this.show = true;
								this.download = false;
								this.csvFieldsForXls[this.$t('activities.activityname')]='activityname',
								this.csvFieldsForXls[this.$t('activities.ActivityDetailsId')]='activitydetailsid',
								this.csvFieldsForXls[this.$t('warehouseRacks.rackId')]='rackid',
								this.csvFieldsForXls[this.$t('activities.scannedStock')]='physicalstock',
								this.csvFieldsForXls[this.$t('activities.WhRackStock')]='whrackstock',
								this.csvFieldsForXls[this.$t('activities.SkuCount')]='skucount',
								this.csvFieldsForXls[this.$t('loginUsers.userId')]='userid',
								this.csvFieldsForXls[this.$t('auditReport.startDate')]='actualstartdate',
								this.csvFieldsForXls[this.$t('common.endDate')]='actualenddate',
								this.csvFieldsForXls[this.$t('common.assignedTo')]='assignedto',
								this.csvFieldsForXls[this.$t('activities.taskStatus')]='taskstatus',
								this.csvFieldsForXls[this.$t('activities.activityStatus')]='activitystatus',
								this.csvFieldsForXls[this.$t('activities.estimatedStartDate')]='estartdate',
								this.csvFieldsForXls[this.$t('activities.estimatedEndDate')]='eenddate',

								this.ActivityListXls = result.data.data
								this.isLoading = false;
								return true;
							}
							if (this.listingtype == 'planlisting' && result.data.data.length > 0) {
								this.listActivitydata = result.data.data;
								this.resultCount = result.data.data[0].rowcount;
								this.totalRows = Number(result.data.data[0].rowcount);
								this.setPageCounts(result.data.data[0].rowcount);
							}
							else if (this.listingtype == 'planlisting' && result.data.data.length == 0) {
								this.totalRows = 0
								this.totalRows = 0;
								this.listActivitydata = [];
								this.resultCount = 0;
							}
							else {
								this.tasklisting = result.data.data;
							}
							this.isLoading = false;
							this.searchFlag = true
						}, error => {
							console.error(error);
						})
				} else {
					this.listActivitydata = [];
					this.resultCount = 0;
					this.setPageCounts(0);

					if (!this.clientid) {
						this.ClientErr = this.$t('common.clientError');
					}
					if (!this.warehouseid) {
						this.ClientErr = this.$t('common.warehouseError');
					}
				}
			})
		},
		showRow(data) {
			// //////
			this.resetAssignData();
			this.activitydata = data;
			this.listingtype = 'tasklisting';
			this.contentVisible = true;
			this.download = true;
			this.id = data.activitydetailsid;
			data.contentVisible = data.contentVisible == true ? false : true;
			this.geActivitydata()
			this.toCheckShowRowIndex = Number(this.listActivitydata.indexOf(data))
			for (var i = 0; i < this.listActivitydata.length; i++) {
				if (this.listActivitydata[i].contentVisible == true && i != this.toCheckShowRowIndex) {
					this.listActivitydata[i].contentVisible = false
				} else {

				}
			}
			// data.contentVisible = !data.contentVisible;
			const index = this.opened.indexOf(data.tripid);
			if (index > -1) {
				this.opened.splice(index, 1)
			} else {
				this.opened = []
				this.opened.push(data.tripid)
			}
		},
		getUesrsList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.userListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		onPageChange(page) {
			this.currentPage = page;
			this.contentVisible = false;
			this.geActivitydata(2)
		},
		async callParent2(data) {
			this.showadd = true;
			this.showlist = true;
			if (data) {
				this.clientid = data.clientid;
				this.warehouseid = data.warehouseid;
				this.activitytypesearch = data.activitytypeid;
				await this.geActivitydata(2);
				//this.showRow(this.listActivitydata[0])
			}
		},
		async callParent() {
			this.showadd = true;
			this.showlist = true;
			await this.geActivitydata(2);
		},
		showAddForm() {
			this.showadd = false;
		},
		showEditForm(data) {
			this.selectedRow = data
			this.selectedRow['clientid'] = this.clientid
			this.selectedRow['warehouseid'] = window.localStorage.getItem('selectedWarehouse')
			this.showlist = false;
		},

		//Sets total number of pages
		setPageCounts(total_rows) {

			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
			//alert(this.totalPage)
		},


		resetFormData() {
			this.orderid = '';
			this.id = '';
			this.activitytypesearch = '';
			this.fromDateFlt = '';
			this.toDateFlt = '';
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.totalPage = 0;
			// this.listActivitytypeData = [];
			// this.listActivitydata = [];
			this.resultCount = 0;
			this.ClientErr = "";
			this.resultCount = this.totalRows = 0;
			this.WarehouseErr = "";
			this.assignee = "";
			this.searchstatus = "";
			// if (this.user_type == 'warehouse_user') {
			// 	this.clientid = '';
			// } else if (this.user_type == 'client_user') {
			// 	this.warehouseid = '';
			// } else {
			// 	this.clientid = '';
			// 	// this.warehouse = '';
			// 	this.warehouseid = '';
			// }
		},

		onSubmit: function (e) {
			this.$validator
				.validateAll()
				.then((result) => {
					if (result) {
						console.log("form is valid", this.model);
						event.target.reset();
					} else {
						return false;
					}

				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/activitylist/activitylist.component.js